import React, { useState } from "react";
import {
    Card,
    CardBody,
    Container,
    Nav,
    NavItem,
    NavLink,
    Row,
} from "reactstrap";
import classnames from "classnames";
import withRouter from "components/Common/withRouter";

/* ================= TABS ================= */

const tabs = ["All", "Candidate", "AI", "Client"];

/* ================= NOTIFICATIONS DATA ================= */

const notifications = [
    {
        id: 1,
        company: "OS Enterprises, Inc. (Montgomery)",
        action: "gave feedback to",
        user: "NICHOLAS STALLWORTH",
        time: "10 DAYS AGO",
        unread: true,
        category: "Candidate",
    },
    {
        id: 2,
        company: "OS Enterprises, Inc. (Montgomery)",
        action: "gave feedback to",
        user: "ADAM WILLIAMS",
        time: "10 DAYS AGO",
        unread: true,
        category: "Candidate",
    },
    {
        id: 3,
        company: "OS Enterprises, Inc. (Montgomery)",
        action: "gave feedback to",
        user: "PRIA GRAY",
        time: "10 DAYS AGO",
        unread: true,
        category: "Candidate",
    },
    {
        id: 4,
        company: "Accudelivery Inc (IN)",
        action: "gave feedback to",
        user: "DARON HINES",
        time: "10 DAYS AGO",
        unread: true,
        category: "Client",
    },
    {
        id: 5,
        company: "Accudelivery Inc (IL)",
        action: "gave feedback to",
        user: "ANTHONY HOLMES",
        time: "10 DAYS AGO",
        unread: false,
        category: "Client",
    },
];

/* ================= COMPONENT ================= */

const AllNotifications = () => {
    const [activeTab, setActiveTab] = useState("All");

    const filteredNotifications =
        activeTab === "All"
            ? notifications
            : notifications.filter((n) => n.category === activeTab);

    return (
        <div className="page-content">
            <Container fluid>
                <Card className="border">
                    <CardBody>
                        <Row className="align-items-center g-2">
                            {/* HEADER */}
                            <div className="notification-header pt-3">
                                <h5 className="mb-1">Notifications</h5>
                                <small className="text-muted">
                                    You have {notifications.filter(n => n.unread).length} unread messages
                                </small>
                            </div>

                            {/* TABS (UNCHANGED) */}
                            <Nav tabs className="border-0 d-flex flex-nowrap px-2 mt-3">
                                {tabs.map((tab) => (
                                    <NavItem key={tab}>
                                        <NavLink
                                            onClick={() => setActiveTab(tab)}
                                            className={classnames("px-3 py-2", {
                                                active: activeTab === tab,
                                            })}
                                            style={{
                                                background: "transparent",
                                                fontWeight: activeTab === tab ? "bold" : "normal",
                                                color: activeTab === tab ? "#000" : "#999",
                                                cursor: "pointer",
                                                border: "none",
                                                position: "relative",
                                            }}
                                        >
                                            {tab}
                                            {activeTab === tab && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        height: "3px",
                                                        backgroundColor: "#0d1b6e",
                                                        width: "100%",
                                                        bottom: 0,
                                                        left: 0,
                                                        borderRadius: "2px",
                                                    }}
                                                />
                                            )}
                                        </NavLink>
                                    </NavItem>
                                ))}
                            </Nav>

                            {/* BODY */}
                            <div className="mt-2">
                                {filteredNotifications.length > 0 ? (
                                    filteredNotifications.map((item) => (
                                        <NotificationItem key={item.id} {...item} />
                                    ))
                                ) : (
                                    <div className="text-center text-muted py-4">
                                        No notifications
                                    </div>
                                )}
                            </div>

                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

/* ================= NOTIFICATION ITEM ================= */

const NotificationItem = ({
    company,
    action,
    user,
    time,
    unread,
}) => (
    <div
        className={`d-flex align-items-start px-3 py-3 border-bottom`}
        style={{ cursor: "pointer" }}
    >
        {/* ICON */}
        <div className="me-3 mt-1">
            <div
                className={`rounded-circle d-flex align-items-center justify-content-center ${unread ? "bg-warning" : "bg-secondary"
                    }`}
                style={{ width: 36, height: 36 }}
            >
                <i className="fa fa-file text-white" />
            </div>
        </div>

        {/* CONTENT */}
        <div className="flex-grow-1">
            <div className="fw-normal">
                {company}{" "}
                <span className="fw-normal text-muted">{action}</span>{" "}
                <span className="fw-normal">{user}</span>
            </div>

            <div className="text-muted mt-1 d-flex align-items-center">
                <i className="fa fa-clock me-2" />
                <small>{time}</small>
            </div>
        </div>
    </div>
);

export default withRouter(AllNotifications);
